import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from '../../../helpers/config';
import { getPrepareHeaders } from '../get-prepare-headers';
import {
  AplikimeNderVite,
  KonkurrimeCards,
  PranuarRefuzuar,
  ShperndarjaProfilit,
  ShperndarjaStatusit,
  VitiKonkurrimitFilter,
} from '../../../interfaces/dashboard';

const {
  test: { baseUrl },
} = getConfig();

export const dashboardKonkurrimeApi = createApi({
  reducerPath: 'dashboardKonkurrimeStats',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['DashboardStats'],
  endpoints: builder => ({
    getAplikimeNderVite: builder.query<AplikimeNderVite[], void>({
      query: () => ({
        url: '/statistika-konkurrime/aplikime-nder-vite',
      }),
    }),

    getShperndarjaStatusit: builder.query<
      ShperndarjaStatusit[],
      VitiKonkurrimitFilter
    >({
      query: ({ vitiKonkurrimit }) => ({
        url: `/statistika-konkurrime/shperndarja-aplikimeve-sipas-statusit/${vitiKonkurrimit}`,
      }),
    }),

    getShperndarjaProfilit: builder.query<
      ShperndarjaProfilit[],
      VitiKonkurrimitFilter
    >({
      query: ({ vitiKonkurrimit }) => ({
        url: `/statistika-konkurrime/aplikime-sipas-profilit/${vitiKonkurrimit}`,
      }),
    }),

    getPranuarRefuzuar: builder.query<PranuarRefuzuar[], void>({
      query: () => ({
        url: 'statistika-konkurrime/aplikime-pranuar-refuzuar',
      }),
    }),

    getKonkurrimeCards: builder.query<KonkurrimeCards, VitiKonkurrimitFilter>({
      query: ({ vitiKonkurrimit }) => ({
        url: `/statistika-konkurrime/cards/${vitiKonkurrimit}`,
      }),
    }),
  }),
});

export const {
  useGetAplikimeNderViteQuery,
  useGetShperndarjaStatusitQuery,
  useGetShperndarjaProfilitQuery,
  useGetPranuarRefuzuarQuery,
  useGetKonkurrimeCardsQuery,
} = dashboardKonkurrimeApi;
